import React from "react";
import { FieldProps } from "./Field/types";
import { Td } from "ui/Table";

interface Props<TRecord> {
    record: TRecord;
    field: React.ReactElement<FieldProps>;
}

const DatagridCell = <TRecord,>({ record, field }: Props<TRecord>) => {
    return (
        <Td>
            {React.cloneElement(field, {
                record,
            })}
        </Td>
    );
};

export default DatagridCell;
